// src/App.js
import React, { useState, useEffect } from 'react';
import { Routes, Route } from 'react-router-dom'; // BrowserRouter is in index.js
import axios from 'axios';
import API_BASE_URL from './apiConfig.js';
import AppShell from './app/AppShell.jsx';
import HomeScreen from './app/index.jsx';
import ViewCustomers from './app/view-customers.jsx';
import CreateInvoice from './app/create-invoice.jsx';
import CreateAccount from './app/create-account.jsx';
import CreateQuote from './app/create-quote.jsx';
import CustomerDetails from './app/customer-details.jsx';
import CustomerInvoices from './app/customer-invoices.jsx';
import CustomerJobs from './app/customer-jobs.jsx';
import CustomerQuotes from './app/customer-quotes.jsx';
import Forgot from './app/forgot.jsx';
import InvoiceDetails from './app/invoice-details.jsx';
import Invoices from './app/invoices.jsx';
import JobDetails from './app/job-details.jsx';
import Jobs from './app/jobs.jsx';
import Login from './app/login.jsx';
import NewCustomer from './app/new-customer.jsx';
import NewJob from './app/new-job.jsx';
import QuoteDetails from './app/quote-details.jsx';
import Quotes from './app/quotes.jsx';
import Schedule from './app/schedule.jsx';
import Settings from './app/settings.jsx';
import AddUser from './app/add-user.jsx';
import ConfirmAccount from './app/confirm-account.jsx';
import Users from './app/users.jsx';
import UserDetails from './app/user-details.jsx';
import PasswordReset from './app/password-reset.jsx';
import ChangePassword from './app/change-password.jsx';
import VAiGPT from './app/vai-gpt.jsx';
import VAi from './app/vai.jsx';
import CalendarPage from './app/calendar.jsx';

export default function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkUserSignedIn = async () => {
      try {
        const token = localStorage.getItem('userToken');
        if (!token) {
          setIsAuthenticated(false);
          setIsLoading(false);
          return;
        }

        const response = await axios.get(`${API_BASE_URL}/auth/check`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (response.data.isAuthenticated) {
          setIsAuthenticated(true);
        } else {
          setIsAuthenticated(false);
          localStorage.removeItem('userToken');
          localStorage.removeItem('userPermissions');
        }
      } catch (error) {
        console.error('Error checking user authentication:', error);
        setIsAuthenticated(false);
        localStorage.removeItem('userToken');
        localStorage.removeItem('userPermissions');
      } finally {
        setIsLoading(false);
      }
    };

    checkUserSignedIn();
  }, []);

  if (isLoading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <div>Loading...</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return (
      <Routes>
        <Route path="/login" element={<Login setIsAuthenticated={setIsAuthenticated} />} />
        <Route path="/forgot" element={<Forgot />} />
        <Route path="/create-account" element={<CreateAccount />} />
        <Route path="/confirm-account" element={<ConfirmAccount />} />
        <Route path="/password-reset" element={<PasswordReset />} />
        <Route path="*" element={<Login setIsAuthenticated={setIsAuthenticated} />} />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route element={<AppShell setIsAuthenticated={setIsAuthenticated} />}>
        <Route path="/" element={<HomeScreen />} />
        <Route path="/view-customers" element={<ViewCustomers />} />
        <Route path="/create-invoice" element={<CreateInvoice />} />
        <Route path="/create-account" element={<CreateAccount />} />
        <Route path="/create-quote" element={<CreateQuote />} />
        <Route path="/customer-details" element={<CustomerDetails />} />
        <Route path="/customer-invoices" element={<CustomerInvoices />} />
        <Route path="/customer-jobs" element={<CustomerJobs />} />
        <Route path="/customer-quotes" element={<CustomerQuotes />} />
        <Route path="/add-user" element={<AddUser />} />
        <Route path="/confirm-account" element={<ConfirmAccount />} />
        <Route path="/users" element={<Users />} />
        <Route path="/user-details" element={<UserDetails />} />
        <Route path="/invoice-details" element={<InvoiceDetails />} />
        <Route path="/invoices" element={<Invoices />} />
        <Route path="/job-details" element={<JobDetails />} />
        <Route path="/jobs" element={<Jobs />} />
        <Route path="/new-customer" element={<NewCustomer />} />
        <Route path="/new-job" element={<NewJob />} />
        <Route path="/quote-details" element={<QuoteDetails />} />
        <Route path="/quotes" element={<Quotes />} />
        <Route path="/schedule" element={<Schedule />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/password-reset" element={<PasswordReset />} />
        <Route path="/change-password" element={<ChangePassword />} />
        <Route path="/vai-gpt" element={<VAiGPT />} />
        <Route path="/vai" element={<VAi />} />
        <Route path="/calendar" element={<CalendarPage />} />
      </Route>

      <Route path="/login" element={<Login />} />
      <Route path="/forgot" element={<Forgot />} />
    </Routes>
  );
}
